<template>
    <div :id="'device-' + this.device_id" class="device-component">
        <div class="panel panel-default">
            <div class="panel-heading">
                <select @change="onChangedDeviceEnvironment"
                        v-model="environment_id"
                        v-bind:disabled="mode === 'view' || mode === 'modify' || environmentId !== undefined" class="form-control">
                    <option value="">장비 유형을 선택하세요</option>
                    <option v-for="environment in environments"
                            v-text="environment.title"
                            v-bind:value="environment.id"></option>
                </select>
            </div>
            <div class="panel-body">

                <alert :alert="alert"></alert>

                <div v-for="attribute in attributes"
                     v-bind:key="attribute.id"
                     v-if="showTheAttribute(attribute)">

                    <p v-text="attribute.title"></p>

                    <div v-if="attribute.input_type == 'select'">

                        <select class="form-control"
                                @change="onChangedDeviceAttribute"
                                v-bind:disabled="mode === 'view'"
                                v-model="selected_attributes[attribute.id].value">

                            <option value="">선택하세요</option>
                            <option v-for="value in orderByPosition(attribute.children)"
                                    v-text="value.title"
                                    v-bind:value="value.id"
                                    v-bind:selected="selected_attributes[attribute.id] == value.id">
                            </option>
                        </select>

                    </div>
                    <div v-else-if="attribute.input_type == 'checkbox'">

                        <label class="checkbox-inline"
                               v-for="value in orderByPosition(attribute.children)" v-if="mode !== 'view' || selected_attributes[attribute.id].value.indexOf(value.id) > -1">

                            <input type="checkbox"
                                   @change="onChangedDeviceAttribute"
                                   v-model="selected_attributes[attribute.id].value"
                                   v-bind:disabled="mode === 'view'"
                                   v-bind:value="value.id"> {{ value.title }}
                        </label>

                    </div>

                </div>
            </div>
            <div v-if="mode === 'create' || mode === 'modify'" class="panel-footer">
                <button v-if="async_create === true && environment_id != ''" @click.prevent="onSubmit" class="btn btn-block btn-default">
                    {{ mode == "modify" ? "수정" : "생성" }}
                </button>
                <button v-if="mode == 'modify' || (mode == 'create' && async_create === false)" @click.prevent="onDelete" class="btn btn-danger btn-block">
                    삭제
                </button>
            </div>
        </div>

    </div>

</template>

<script>

    import $ from 'jquery'
    import Alert from './Alert'

    export default {
        name: 'device',
        components: {
            'alert': Alert,
        },
        props: ['readonly', 'deviceId', 'relatedId', 'relatedWith', 'environmentId', 'asyncCreate'],
        data () {
            return {
                mode: '',
                data: [],
                device_id: '',
                related_id: '',
                related_with: '',
                environment_id: '',
                async_create: true,
                selected_attributes: [],
                alert: {
                    type: 'danger',
                    is_open: false,
                    title: '알려드립니다.',
                    body: '',
                }
            }
        },
        created() {
            let $this = this;
            let device_id       = Number.parseInt(this.deviceId);
            let related_id      = this.relatedId;
            let related_with    = this.relatedWith;

            this.device_id      = device_id;
            this.related_id     = related_id;
            this.related_with   = related_with;

            this.setMode();

            if (this.asyncCreate !== undefined) {
                this.async_create = this.asyncCreate == "true" ? true : false;
            }

            this.getDeviceMetaTree();

            console.log('device -----------',this);

        },
        computed: {
            environments() {
                return this.orderByPosition(this.data);
            },
            environment() {
                var $this = this;
                var result = _.find(this.data, function (o) {
                    return o.id == $this.environment_id;
                })
                if (result != null) {
                    return result;
                }
                return [];
            },
            attributes() {

                var $this = this;
                var result = _.find(this.data, function (o) {
                    return o.id == $this.environment_id;
                });
                console.log('attributes', $this.environment_id);
                if (result != null) {
                    return this.orderByPosition(result.children);
                }
                return [];
            },
            dependency_attributes() {
                var result = _.filter(this.attributes, function (o) {
                    return o.dependent_attribute_value.length != 0;
                })

                return result;
            },
            dependency_attribute_ids() {
                var ids = [];
                _.each(this.dependency_attributes, function(o) {
                    ids.push(o.id);
                });
                return ids;
            },
            dependency_attribute_map() {
                var map = [];
                _.each(this.dependency_attributes, function(o) {
                    map.push({
                        owner: o.dependent_attribute_value,
                        slave: o.id
                    });
                });
                return map;
            },
            // 실제 화면에 보여지는 속성들이지만, 선택된 값들이 없는 속성들
            not_selected_attributes() {

                let be_not_selected_attributes = _.filter(this.selected_attributes, (selected_attribute, selected_attribute_id) => {
                    return _.indexOf(this.shown_attribute_ids, selected_attribute_id) > -1 && selected_attribute.value == ""
                })

                return be_not_selected_attributes;
            },
            is_validated() {
                return this.environment_id != "" && this.not_selected_attributes.length == 0;
            },
            // 실제 화면에 보여지는 속성들의 객체를 반환한다.
            shown_attributes() {
                let attributes = [];

                _.each(this.attributes, (attribute) => {
                    if(this.showTheAttribute(attribute)) {
                        attributes.push(attribute)
                    }
                });

                return attributes;
            },
            // 실제 화면에 보여지는 속성들의 아이디값들을 반환한다.
            shown_attribute_ids() {
                let ids = [];

                _.each(this.shown_attributes, (attribute) => {
                    ids.push(attribute.id)
                });

                return ids;
            }
        },
        watch: {
            environmentId(new_id, old_id) {
                this.environment_id = this.environmentId;

                if (this.related_with == "project" && this.mode == "create") {
                    this.onChangedDeviceEnvironment();
                } else if (this.related_with == "project" && this.mode == "edit") {

                }

            },
            readonly(new_value, old_value) {
                this.setMode();
            },
            device_id(new_value, old_value) {
                this.setMode();
            },
            deviceId(new_id, old_id) {
                this.device_id = new_id;
                this.loadDevice();
                this.$forceUpdate();
            }

        },
        methods: {
            getDeviceMetaTree() {

                $.ajax({
                    method: "GET",
                    url: "/device/meta/tree"
                })
                .done(( response ) => {
                    this.data = response;

                    if (Number.isInteger(this.device_id) && this.device_id > 0) {
                        this.loadDevice();
                    }

                    if (this.environmentId !== undefined) {
                        this.environment_id = this.environmentId;
                        this.onChangedDeviceEnvironment();
                    }
                });

            },
            setMode() {
                if (this.readonly === 'true' && ! isNaN(this.device_id)) {
                    this.mode = 'view';
                } else if ( ! isNaN(this.device_id)) {
                    this.mode = 'modify';
                } else if (isNaN(this.device_id)) {
                    this.mode = 'create';
                }
            },
            onChangedDeviceEnvironment(event) {
                this.selected_attributes = this.getDataForSelectedAttributes();
            },
            onChangedDeviceAttribute(event) {
                var node_name = event.target.nodeName;
                var attribute_id = event.target.value;
            },
            onDelete() {

                if (this.$parent && this.$parent.$el.id == 'project'
                    && this.$parent.devices && this.$parent.devices.length < 2) {

                    alert("삭제할 수 없습니다. 프로젝트에 등록된 디바이스가 최소 하나 이상이어야 합니다.");

                    return false;
                }

                if (confirm("정말 삭제하시겠습니까?")) {

                    if ( ! this.async_create) {
                        return this.$emit('deleted', this.device_id);
                    }

                    $.ajax({
                        method: "POST",
                        url: "/device/" + this.device_id,
                        data: {
                            _method: 'delete'
                        }
                    })
                    .done(( response ) => {
                        this.environment_id = "";
                        this.mode           = "create";

                        this.$emit('deleted', this.device_id);
                        this.$parent.$emit('deleted', this.device_id);
                    });

                }
            },
            onSubmit() {
                var $this = this;

                if ( ! this.is_validated) {
                    $this.alert.body = "디바이스 속성 정보를 선택하세요.";
                    $this.alert.is_open = true;

                    return false;
                }

                // 생성
                if (this.mode === 'create') {
                    $.ajax({
                        method: "POST",
                        url: "/device",
                        data: {
                            related_id: $this.related_id,
                            related_with: $this.related_with,
                            environment_id: $this.environment_id,
                            attributes: this.create_return_selected_attributes($this.selected_attributes)
                        }
                    })
                    .done(function( response ) {
                        $this.mode = 'modify';
                        $this.device_id = response.id;
                        $this.loadDevice();

                        $this.$emit('created', response.id);
                        $this.$parent.$emit('created', $this.device_id);
                    });
                }
                // 수정
                else if (this.mode === 'modify') {
                    $.ajax({
                        method: "POST",
                        url: "/device/" + $this.device_id,
                        data: {
                            _method: 'put',
                            related_id: $this.related_id,
                            related_with: $this.related_with,
                            environment_id: $this.environment_id,
                            attributes: this.create_return_selected_attributes($this.selected_attributes),
                        }
                    })
                    .done(function( response ) {
                        $this.alert.type = "info";
                        $this.alert.body = "정상적으로 수정되었습니다.";
                        $this.alert.is_open = true;

                        $this.$emit('updated', $this.device_id);
                        $this.$parent.$emit('updated', $this.device_id);

                        $this.loadDevice();
                    });
                }


            },
            showTheAttribute(attribute) {
                var $this = this;
                var dependent_attribute_value = attribute.dependent_attribute_value;

                if (dependent_attribute_value.length == 0) {
                    return true;
                }

                var matched = _.filter(this.selected_attributes, function (o) {
                    return _.indexOf(dependent_attribute_value, o.value) != -1;
                })

                if (matched.length > 0) {
                    return true;
                }

                this.selected_attributes[attribute.id].value = "";

                return false;
            },
            getDataForSelectedAttributes(data) {
                var result = {};
                _.each(this.attributes, function (o) {

                    var basket = {
                        data: o,
                        children: o.children,
                        value: '',
                        required: true,
                    }

                    if (o.input_type == 'checkbox') {
                        basket.value = [];
                    }

                    if (data !== undefined && data[o.id] !== undefined) {

                        if (o.input_type == "select") {
                            basket.value = data[o.id][0];
                        } else if (o.input_type == "checkbox") {
                            basket.value = data[o.id];
                        }

                    }

                    result[o.id] = basket;

                })
                return result;
            },
            orderByPosition(data) {
                return _.sortBy(data, function (attribute) {
                    return parseInt(attribute.position, 10);
                });

                // return _.orderBy(data, ['position'], ['asc'])
            },
            getAttributeByValueId(id) {
                var attribute_id = '';
                _.each(this.attributes, function(attribute) {
                    _.each(attribute.children, function(value) {
                        if (id == value.id) {
                            attribute_id = attribute.id;
                        }
                    })
                })
                return attribute_id;
            },
            loadDevice() {
                var $this = this;

                $.ajax({
                    method: "GET",
                    url: "/device/" + this.device_id,
                })
                .done(function( response ) {

                    $this.environment_id    = response.device_environment_id;
                    $this.related_with      = response.related_with;
                    $this.related_id        = response.related_id;

                    var attributes = {};

                    _.each(response.attribute, function (o) {

                        if (attributes[o.device_attribute_key_id] === undefined) {
                            attributes[o.device_attribute_key_id] = []
                        }

                        attributes[o.device_attribute_key_id].push(o.device_attribute_value_id)
                    });

                    $this.selected_attributes= $this.getDataForSelectedAttributes(attributes);
                });
            },
            create_return_selected_attributes(selected_attributes) {
                let return_data = {}
                _.each(selected_attributes, (attribute, key) => {
                    return_data[key] = {
                        value: attribute.value,
                        required: attribute.request
                    }
                })
                return return_data;
            }
        }
    }

</script>

<style>
    .device-component {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/Device.vue